import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { IndicatorDetails, IndicatorDetailsRoutes } from '../utils';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChartLine,
  faRulerHorizontal,
} from '@fortawesome/pro-light-svg-icons';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { numberWithCommas } from 'shared/utils/numberUtils';

const unknownText = 'Not yet answered';
const currentQuestionText = '(Current question)';
const StyledDiv = styled.div`
  padding: ${SPACERS.small} ${SPACERS.large};
  .forecast {
    margin-bottom: ${SPACERS.tiny};
    .icon-container {
      width: 24px;
      height: 24px;
      .icon {
        margin-top: 3px;
        width: 24px;
        height: 18px;
      }
    }
  }
  .measurement {
    .icon-container {
      margin-top: -3px;
      width: 24px;
      height: 24px;
      .icon {
        width: 24px;
        height: 24px;
      }
    }
  }
  & > div {
    display: flex;
    gap: ${SPACERS.extraTiny};
  }
`;

export const indicatorHeaderTooltip = ({
  route,
  indicator,
  isCurrentIndicatorSelected,
}: {
  programName?: string;
  serviceGoal?: string;
  serviceType?: string;
  intermediaries?: string;
  indicator: IndicatorDetails;
  route: IndicatorDetailsRoutes;
  isCurrentIndicatorSelected: boolean;
}) => {
  const forecast = indicator.finalForecast || indicator.forecast;
  const isForecastQuestion = isCurrentIndicatorSelected && route === 'forecast';
  const isMeasurementQuestion =
    isCurrentIndicatorSelected && route === 'measurement';
  return (
    <StyledDiv>
      <div className="forecast">
        <div className="icon-container">
          <FontAwesomeIcon
            icon={faChartLine}
            color={forecast ? COLORS.success : COLORS.grayDark}
            className="icon"
          />
        </div>
        <TrueImpactText variant="body">
          <strong>
            {forecast
              ? numberWithCommas(forecast)
              : isForecastQuestion
                ? currentQuestionText
                : unknownText}
          </strong>{' '}
          {forecast
            ? indicator.indicatorName
            : `How many ${indicator.indicatorName.toLowerCase()}`}
        </TrueImpactText>
      </div>
      <div className="measurement">
        <div className="icon-container">
          <FontAwesomeIcon
            icon={faRulerHorizontal}
            color={indicator.measurement ? COLORS.success : COLORS.grayDark}
            className="icon"
          />
        </div>
        <TrueImpactText variant="body-small">
          <strong>Measurement type:</strong>{' '}
          {indicator.measurement
            ? indicator.measurement
            : isMeasurementQuestion
              ? currentQuestionText
              : unknownText}
        </TrueImpactText>
      </div>
    </StyledDiv>
  );
};
